import * as React from 'react';
import css from './vertical-timeline-element.css';
import classify from 'src/utils/classify';


export type VerticalTimelineElementProps = {
  id: number;
  header?: React.ReactNode;
  icon?: React.ReactNode;
  isInProgress?: boolean;
  circleColor?: string;
  lineStyle?: 'solid' | 'dashed';
  lineColor?: string;
  children?: React.ReactNode;
};

export const VerticalTimelineElement = (
  props: VerticalTimelineElementProps,
) => {
  const {
    lineStyle,
    lineColor,
    icon,
    isInProgress,
    circleColor,
    header,
    children,
  } = props;
  const customStyle: Record<string, any> = {};
  if (lineStyle) {
    customStyle['--lineStyle'] = lineStyle;
  }
  if (lineColor) {
    customStyle['--lineColor'] = lineColor;
  }
  return (
    <div className={css.timelineElementContainer} style={customStyle}>
      {props.icon ? (
        <div className={css.timelineIcon}>{icon}</div>
      ) : (
        <div
          className={classify(css.timelineCircle, {
            [css.loading]: isInProgress,
          })}
          style={circleColor ? {backgroundColor: circleColor} : {}}
        ></div>
      )}

      <div className={css.timelineContent}>
        {!!header && <div className={css.headerBlock}>{header}</div>}
        <div className={css.customComponent}>{children}</div>
      </div>
    </div>
  );
};
